import { render, staticRenderFns } from "./BuyBean.vue?vue&type=template&id=c3da53b4&scoped=true&"
import script from "./BuyBean.vue?vue&type=script&lang=js&"
export * from "./BuyBean.vue?vue&type=script&lang=js&"
import style0 from "./BuyBean.vue?vue&type=style&index=0&id=c3da53b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3da53b4",
  null
  
)

export default component.exports